import { chatMessageFragment } from '../fragments';
import { makeRequest } from '../utils';

/**
 * @param {string} chatId
 * @param {string} attachmentId
 */
export const nextChatMessageAttachment = (chatId, attachmentId) =>
  makeRequest({
    operationName: 'NextChatMessageAttachment',
    query: `
      query NextChatMessageAttachment($chatId: String!, $attachmentId: String!) {
        nextChatMessageAttachment(chatId: $chatId, attachmentId: $attachmentId) {
          id
          name
          url
          countBefore
          countAfter
        }
      }
    `,
    variables: { chatId, attachmentId },
  });

/**
 * @param {string} chatId
 * @param {string} attachmentId
 */
export const previousChatMessageAttachment = (chatId, attachmentId) =>
  makeRequest({
    operationName: 'PreviousChatMessageAttachment',
    query: `
      query PreviousChatMessageAttachment($chatId: String!, $attachmentId: String!) {
        previousChatMessageAttachment(chatId: $chatId, attachmentId: $attachmentId) {
          id
          name
          url
          countBefore
          countAfter
        }
      }
    `,
    variables: { chatId, attachmentId },
  });
